import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

// NEW
import attachment from '@/store/attachment/index'

import authentication from '@/views/Authentication/store/authentication'

import authorization from '@/store/authorization/index'
import comment from '@/store/comment/index'
import company from '@/store/company/index'
// DOCUMENT
import translation from '@/store/translation/index'
// LOG
import notification from '@/store/notification/index'

import observation from '@/store/observation/index'
import project from '@/store/project/index'
import task from '@/store/task/index'
import user from '@/store/user/index'
// WATCHER
import helpers from '@/store/helpers/index'

import language from '@/views/Language/store/index'

// Contractor
import contractor from '@/store/contractor'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
})

export default new Vuex.Store({
    strict: true,

    modules: {
        ...attachment,
        ...authentication,
        ...authorization,
        ...contractor,
        ...comment,
        ...company,
        ...language,
        ...translation,
        ...notification,
        ...observation,
        ...project,
        ...task,
        ...user,

        ...helpers,
    },

    actions: {
        clearAll({ commit }) {
            commit('resetAttachment')
            commit('resetAuthentication')
            commit('resetAuthorization')
            commit('resetComment')
            commit('resetCompany')
            commit('resetNotification')
            commit('resetObservation')
            commit('resetProject')
            commit('resetTask')
            commit('resetUser')
            commit('resetContractor')
        },
    },

    plugins: [vuexLocal.plugin],
})
